import React from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { TopOpportunity } from 'apps/sigma2-ui/src/lib/top-opportunities';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { MetricDefinition } from 'libs/end-to-end/src/types/databases/metrics/metric-definition';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';

export interface TopOpportunitiesSectionProps {
  opportunities: TopOpportunity[];
  // Slot
  card: (props: {
    opportunity: TopOpportunity;
    key: string;
  }) => React.ReactElement;
  metricDefinition: MetricDefinition | null;
  calibrationFraming: CalibrationFraming;
}

export const TopOpportunitiesSection: React.FC<
  TopOpportunitiesSectionProps
> = ({ opportunities, card, metricDefinition, calibrationFraming }) => {
  const language = useLanguage();

  if (opportunities.length === 0) {
    return (
      <Spacing direction="vertical" size="lg" className="w-full">
        <S2Typography
          variant="headline-5"
          translatedContent={language.dataIntelligenceTopOpportunities({
            config: metricDefinition
              ? 'largest-differences'
              : 'top-opportunities',
          })}
        />

        <Spacing
          direction="vertical"
          size="md"
          className="py-20 px-12 bg-white items-center w-full"
        >
          <S2Typography
            variant="headline-6-alt"
            translatedContent={language.dataIntelligenceTopOpportunitiesEmptyTitle(
              {
                processesDescription:
                  metricDefinition?.whiteLabeling?.proceseesDescription ?? null,
              },
            )}
          />

          <S2Typography
            variant="body-7"
            translatedContent={language.dataIntelligenceTopOpportunitiesEmptyBody(
              {
                processesDescription:
                  metricDefinition?.whiteLabeling?.proceseesDescription ?? null,
                calibrationFraming,
              },
            )}
          />
        </Spacing>
      </Spacing>
    );
  }

  return (
    <Spacing direction="vertical" size="lg">
      <S2Typography
        variant="headline-5"
        translatedContent={language.dataIntelligenceTopOpportunities({
          config: metricDefinition
            ? 'largest-differences'
            : 'top-opportunities',
        })}
      />

      <Spacing
        size="md"
        direction="horizontal"
        className="space-between items-stretch flex-wrap"
      >
        {opportunities.slice(0, 3).map((opportunity, index) => {
          return card({
            opportunity,
            // Note: this will need to be changed if we ever introduce sorting
            // updates to the cards
            key: index.toString(),
          });
        })}
      </Spacing>
    </Spacing>
  );
};
